import React              from 'react';
import PropTypes          from 'prop-types';
import Flux               from '../../../../flux/Flux';
import Translations       from '../../../../utils/Translations';
import {VXPay}            from '../../../../utils/VXPay';
import MiddleBlock        from './MiddleBlock';
import ItemDescription    from './ItemDescription';
import DailyBonusOfferBtn from '../../../Dailybonus/SubComponents/DailyBonusOfferBtn';
import OfferIcon          from '../../../Dailybonus/SubComponents/OfferIcon';
import {
	isMerchAndHasCode, needVipYesterdayOffer,
}                         from '../../../Dailybonus/dailyBonusHelpers';

class DailybonusPrevDayItemItem extends React.Component {

	constructor(props) {
		super(props);
		this.needVipYesterdayOffer = needVipYesterdayOffer(this.props.bonusOffer.conditions);
		this.onClickVip            = this.onClickVip.bind(this);
	}

	onClickVip(e) {
		e.preventDefault();
		e.stopPropagation();

		if (!Flux.Guest.isLoggedIn()) {
			VXPay.openLogin();
			return;
		}
		VXPay.openAboPaytour();
	}

	render() {
		const {bonusOffer} = this.props;

		const isVip    = Flux.Guest.isVip();
		const showBlur = this.needVipYesterdayOffer ? !isVip : false;
		const hasCode  = isMerchAndHasCode(bonusOffer.offer, bonusOffer.effect);
		const classes  = ['dailybonus__mobile--item', 'yearstaday'];
		hasCode && classes.push('-has-code');

		return (
			<div className={classes.join(' ')}>
				<div className="dailybonus__mobile--item__headline">
					<h3>
						<OfferIcon offer={bonusOffer.offer} purchased={bonusOffer.purchased} />{Translations.get('YearstadayBonusMobileHeadLine')}
					</h3>
				</div>
				<div className='dailybonus__mobile--item__content'>
					<div className={showBlur ? 'blur' : ''}>
						<MiddleBlock  {...bonusOffer} />
						<ItemDescription bonusOffer={bonusOffer} />
						<DailyBonusOfferBtn {...bonusOffer} isOutlineButton={true} isCurrencyVoucher={true}/>
					</div>
					{
						showBlur &&
						<div className='dailybonus__mobile--item__not-vip-overlay'>
							<div className="dailybonus__mobile--item__not-vip-overlay__icon"><i className='icon -icon-person-vip' /></div>
							<div className="dailybonus__mobile--item__not-vip-overlay__text">{Translations.get('YearstadayBonusNotVIPYet')}</div>
							<div className="dailybonus__mobile--item__not-vip-overlay__btn-wrapper">
								<a className="dailybonus__mobile--item__not-vip-overlay__btn-wrapper--url" onClick={this.onClickVip}>
									{Translations.get('YearstadayBonusBecomeVIP')}
								</a>
							</div>
						</div>
					}
				</div>
			</div>
		);
	}
}

DailybonusPrevDayItemItem.propTypes = {
	bonusOffer: PropTypes.shape({
		date:       PropTypes.string,
		offer:      PropTypes.string,
		purchased:  PropTypes.bool,
		conditions: PropTypes.array,
		effect:     PropTypes.object,
		quantity:   PropTypes.number,
		content:    PropTypes.object,
	}).isRequired,
};

export default DailybonusPrevDayItemItem;
